export default __webpack_public_path__ + "f5f7d13cff6e5c2b8e6061063e2197e6.png";